// components/pages/UnauthorizedPage.js - Página de acceso no autorizado
import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle, faHome, faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const UnauthorizedPage = () => {
  const navigate = useNavigate();
  const { logout, user } = useAuth();

  const handleGoHome = () => {
    navigate('/');
  };

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <div className="min-vh-100 d-flex align-items-center bg-light">
      <Container>
        <Row className="justify-content-center">
          <Col xs={12} sm={10} md={8} lg={6}>
            <Card className="shadow text-center">
              <Card.Body className="p-5">
                <div className="mb-4">
                  <FontAwesomeIcon 
                    icon={faExclamationTriangle} 
                    size="4x" 
                    className="text-warning"
                  />
                </div>
                
                <h1 className="h2 mb-3">Acceso No Autorizado</h1>
                
                <p className="text-muted mb-4">
                  No tienes permisos para acceder a esta página.
                  {user && (
                    <>
                      <br />
                      <small>
                        Usuario actual: <strong>{user.fullName}</strong>
                        <br />
                        Roles: {user.roles?.map(role => 
                          typeof role === 'string' ? role : role.name
                        ).join(', ') || 'Sin roles'}
                      </small>
                    </>
                  )}
                </p>

                <div className="d-grid gap-2 d-md-flex justify-content-md-center">
                  <Button 
                    variant="primary" 
                    onClick={handleGoHome}
                    className="me-md-2"
                  >
                    <FontAwesomeIcon icon={faHome} className="me-2" />
                    Ir al Inicio
                  </Button>
                  
                  <Button 
                    variant="outline-secondary" 
                    onClick={handleLogout}
                  >
                    <FontAwesomeIcon icon={faSignOutAlt} className="me-2" />
                    Cerrar Sesión
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default UnauthorizedPage; 